/** 导出ffb层 (Front for backend) */
import type { AppFfbsConfig } from '@zto/zpage'

export const ffbs: AppFfbsConfig = {
  // 获取IoT形象店编码
  'iot.getDepotInfoByDepotCodeOrName$': {
    afterResponse: (response: any) => {
      const data = response?.data
      if (data?.result) {
        const resultData = data.result.map((it: any) => {
          return { ...it, depotLabel: `${it.depotName}（${it.depotCode}）` }
        })

        data.result = {
          data: resultData
        }
      }
      return response
    }
  }
}
